/**
 * Created by razial on 22.05.2025.
 */

const DataSlots = function () {
    this.cache = {};
};

DataSlots.prototype.reset = function () {
    Meta.SLOTS.forEach((slotId) => {
        this.getSlot(slotId);
    });

    for (const slotId in this.cache) {
        this.cache[slotId].reset();
    }
};

DataSlots.prototype.getSlot = function (slotId) {
    let slot = this.cache[slotId];
    if (slot) {
        return slot;
    }

    slot = this.createSlot(slotId);
    if (slot) {
        this.cache[slotId] = slot;
        return slot;
    }

    return new FakeSlot(slotId);
};

DataSlots.prototype.createSlot = function (slotId) {
    if (Meta.SLOTS.indexOf(slotId) === -1) {
        return undefined;
    }

    return new UniversalSlot(slotId);
};
